import * as preact from "preact";

import { getRandomScenario } from "shared/contextScenarios";
import stores from "stores/stores";

interface Props {
  onGenerate: (scenario: string, difficulty: string) => void;
}

interface State {
  scenario: string;
  difficulty: string;
}

const difficultyOptions = [
  { value: "beginner", label: "Beginner (A1-A2)" },
  { value: "intermediate", label: "Intermediate (B1-B2)" },
  { value: "advanced", label: "Advanced (C1-C2)" },
];

export default class GenerateContextModal extends preact.Component<
  Props,
  State
> {
  inputInitialized = false;

  constructor(props: Props) {
    super(props);
    this.state = {
      scenario: getRandomScenario(),
      difficulty:
        (stores.user.state.value.contextDifficulty as string) || "intermediate",
    };
  }

  onDifficultyChange = (difficulty: string) => {
    this.setState({ difficulty });
    stores.user.save({ contextDifficulty: difficulty });
  };

  render() {
    const { onGenerate } = this.props;
    const { scenario, difficulty } = this.state;

    return (
      <div class="generateContextModal">
        <div class="generateContextField">
          <label>Topic / Scenario</label>
          <div class="scenarioInputRow">
            <input
              type="text"
              value={scenario}
              onInput={(event) =>
                this.setState({ scenario: event.currentTarget.value })
              }
              class="scenarioInput"
              ref={(input) => {
                if (input && !this.inputInitialized) {
                  this.inputInitialized = true;
                  setTimeout(() => {
                    input.focus();
                    input.select();
                  }, 100);
                }
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  onGenerate(scenario, difficulty);
                }
              }}
            />
            <button
              class="linkButton shuffleButton"
              onClick={() => this.setState({ scenario: getRandomScenario() })}
              title="Random scenario"
            >
              &#x1f3b2;
            </button>
          </div>
        </div>
        <div class="generateContextField">
          <label>Difficulty</label>
          <div class="difficultySelector">
            {difficultyOptions.map((option) => (
              <button
                key={option.value}
                class={`difficultyOption ${difficulty === option.value ? "selected" : ""}`}
                onClick={() => this.onDifficultyChange(option.value)}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
        <button
          class="generateButton prominent"
          onClick={() => onGenerate(scenario, difficulty)}
        >
          Generate
        </button>
      </div>
    );
  }
}
